import { Component, Input } from '@angular/core';
import { UtilsService } from '../utils/utils.service';

@Component({
  selector: 'app-detail-categories',
  templateUrl: './detail-categories.component.html',
  styleUrls: ['./detail-categories.component.css']
})
export class DetailCategoriesComponent {
  
  @Input() categories: any;
  @Input() unified: any;

  constructor(public utilsService:UtilsService){

  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }
}
